/*

payments/common/lib/utils/addremoveclass

usage:
add a class if it is not already there
remove a class if it is there

return:
the modified input dom node

TODO:
update to use: (support?)
element.classList.add('someClass')

*/

function containsWord(string, word) {
	// string can be:  js-payment__input-cvc-creditcard payment__input-cvc-creditcard input-wrap__input
	// word can be: js-payment__input-cvc-creditcard
	// word is then part of string
	// if word is 'js-payment' then word is not part of string
	const hasValues = Boolean(string && word);
	let anyWordMatches = false;
	if (hasValues) {
		const wordsInString = string.split(/\s/); // separated on space-character
		wordsInString.forEach((w) => {
			if (w === word) {
				anyWordMatches = true;
			}
		});
	}
	return anyWordMatches;
}

function hasClass(elm, classname) {
	let hasIt = false;
	if (elm && elm.className) {
		hasIt = containsWord(elm.className, classname);
	}
	return hasIt;
}

function addClass(elm, classname) {
	if (elm && elm.className) {
		if (!containsWord(elm.className, classname)) {
			elm.className += ` ${classname}`;
		}
	}
	return elm;
}

function removeClass(elm, classname) {
	/* classname must be word characters and not å,ä,ö
	All extra spaces are removed.*/
	const reg = new RegExp(classname, 'g');
	if (elm && elm.className) {
		if (containsWord(elm.className, classname)) {
			elm.className = elm.className.replace(reg, ' ').replace(/\s{1,}/g, ' ');
		}
	}
	return elm;
}
export default {
	add(elm, classname) {
		return addClass(elm, classname);
	},
	remove(elm, classname) {
		return removeClass(elm, classname);
	},
	hasClass(elm, classname) {
		return hasClass(elm, classname);
	}
};

/*
TEST
var containsWord = function (string, word) {
	return new RegExp('\\b' + word + '\\b').test(string);
},
	addClass = function (elm, classname) {
		if (!containsWord(elm.className, classname)) {
			elm.className += ' ' + classname;
		}
		return elm;
	},
	removeClass = function (elm, classname) {
		var reg = new RegExp(classname, 'g');
		if (containsWord(elm.className, classname)) {
			elm.className = elm.className.replace(reg,' ').replace(/\s{1,}/g, ' ');
		}
		return elm;
	};
	var elm = document.createElement('div');
	elm.className = 'ett tva tre fyra fem';
	removeClass(elm,'tre');*/



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/utils/addremoveclass.js